var map = {
	"./calculator.svg": 315,
	"./excel.svg": 316,
	"./exception_frame.png": 317,
	"./exception_frame.svg": 318,
	"./no_calculator.svg": 319,
	"./no_disconnect.svg": 320,
	"./no_headphones.svg": 321,
	"./no_instant_messaging.svg": 322,
	"./no_internet_browsing.svg": 323,
	"./no_leaving_camera.svg": 324,
	"./no_local_browsing.svg": 325,
	"./no_materials.svg": 326,
	"./no_pause.svg": 327,
	"./no_people_in_room.svg": 328,
	"./no_phone.svg": 329,
	"./no_tv_radio.svg": 330,
	"./notes.svg": 331,
	"./pdf.svg": 332,
	"./people_with_interaction.svg": 333,
	"./people_without_interaction.svg": 334,
	"./powerpoint.svg": 335,
	"./rule_frame.png": 336,
	"./rule_frame.svg": 337,
	"./specific_websites.svg": 338,
	"./textbooks.svg": 339,
	"./word.svg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;